<template>
  <v-card flat :width="width">
    <h2 v-if="title">{{ title }}</h2>

    <v-form ref="form" :lazy-validation="true">
      <v-menu
        ref="pickermenu"
        v-model="pickermenu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{on}">
          <v-text-field
            :class="`${addClass}`"
            :outlined="outlined"
            v-model="cmpValue"
            :placeholder="placeholder"
            :append-icon="icon"
            v-on="on"
            @click:append="appendClick"
            :label="label"
            :clearable="clearable"
            :disabled="disabled"
             :hint="hint" 
             :persistentHint="persistentHint"
            :rules="required ? [rules.required] : []"
            @blur="cmpValue = pickerValue = $options.filters.date(Date.parse(cmpValue))"
            @click:clear="$nextTick(() => (cmpValue = pickerValue = null))"
          />
        </template>
        <v-date-picker v-model="pickerValue" :min="minDate" no-title @input="pickermenu = false" :first-day-of-week="1" locale="sv" />
      </v-menu>
    </v-form>
  </v-card>
</template>

<script>
import {RulesMixin} from '@/components/mixins'
import {mapActions, mapGetters} from 'vuex'

// @group Common
// Styled DatePicker component
export default {
  name: 'DatePicker',

  mixins: [RulesMixin],

  props: {
    hint: {
      type: String,
      default: null
    },

    // Keep hint visible even when input is not focused
     persistentHint: {
       type: Boolean,
       default: false
     },

    //The first date to be selectable. 
    minDate: {
      // `'String'`
      type: String,
      // The default value is: `Datum`
      default: ''
    },
    //date from v-modeö
    value: {
      // `'String'`
      type: String
    },
    // Has label
    label: {
      // `'String'`
      type: String,
      // The default value is: `Datum`
      default: 'Datum'
    },
    //has outlined
    outlined: {
      // `true` / `false`
      type: Boolean,
      // The default value is: `false`
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    //it's clearable
    clearable: {
      // `true` / `false`
      type: Boolean,
      // The default value is: `false`
      default: false
    },
    //has title
    title: {
      // `String`
      type: String,
      // The default value is: `''`
      default: ''
    },
    //has addclass
    addClass: {
      // `String`
      type: String,
      // The default value is: `''`
      default: ''
    },
    //the calendar width
    width: {
      type: String,
      default: ''
    },
    //has placeholder
    placeholder: {
      // `String`
      type: String,
      // The default value is: `empty string`
      default: ''
    },
    //is required
    required: {
      // `true` / `false`
      type: Boolean,
      // The default value is: `true`
      default: true
    },
    //is disabled
    disabled: {
      // `true` / `false`
      type: Boolean,
      // The default value is: `false`
      default: false
    }
  },

  data() {
    return {
      //- Pickermenu flag
      pickermenu: false,
      //- Our private copy of value
      cmpValue: null,
      pickerValue: null
    }
  },

  created() {
    //- Handle start value
    this.cmpValue = this.pickerValue = this.$options.filters.date(Date.parse(this.value))
  },

  watch: {
    // @vuese
    //- Make sure we have correct value if it changes i parent
    value(val) {
      this.cmpValue = this.isValidDate(val) ? this.$options.filters.date(val) : val
      this.pickerValue = this.isValidDate(val) ? this.$options.filters.date(val) : null
    },
    cmpValue(val) {
      // @vuese
      //- Tell parent we've changed the value
      this.$emit('input', val === '' ? null : val)
    },
    pickerValue(val) {
      this.cmpValue = val ? val : this.cmpValue
    }
  },

  methods: {
    isValidDate(date) {
      let d = new Date(date)
      return (
        !(Object.prototype.toString.call(d) !== '[object Date]' || isNaN(d.getTime())) &&
        Boolean(date && date.match(/^(\d{4})-(\d{2})-(\d{2})/))
      )
    },
    appendClick() {
      this.pickermenu = true
    }
  }
}
</script>

<style scoped>
</style>